import styled from 'styled-components';

export const InputAreaWrapper = styled.div`
  position: fixed;
  bottom: 3%;
  left: 55%;
  transform: translateX(-50%);
  display: flex;
  justify-content: center;
  width: 100%;
  background-color: transparent;

  @media (max-width: 800px) {
    left: 50%;
  }

`;

export const MessageForm = styled.form`
  display: flex;
  align-items: center;
  padding: 15px;
  background-color: #2a2a2a;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.5);
  border-radius: 15px;
  width: 80%;
  max-width: 800px;
  position: relative;
`;

export const TextInput = styled.textarea`
  flex-grow: 1;
  padding: 10px;
  font-size: 16px;
  border: 1px solid #444444;
  background-color: #2a2a2a;
  color: #ffffff;
  border-radius: 5px;
  margin-right: 10px;
  resize: none;
  height: 20px;
  max-height: 120px;
  overflow: auto;
`;

export const SendButton = styled.button`
  padding: 10px 15px;
  background-color: #4CAF50;
  color: white;
  border: none;
  border-radius: 5px;
  cursor: pointer;
  margin-left: 10px;

  &.audio-received {
    position: static;
  }

  &:hover {
    background-color: #45a049;
  }

  &:disabled {
    background-color: #9e9e9e;
    cursor: not-allowed;
  }
`;

export const CancelButton = styled.button`
  padding: 10px;
  background-color: #FF4136;
  color: white;
  border: none;
  border-radius: 5px;
  cursor: pointer;
  margin-left: 10px;

  &:hover {
    background-color: #ff1c0f;
  }
`;

export const StopButton = styled.button`
  padding: 10px;
  background-color: #FF4136;
  color: white;
  border: none;
  border-radius: 5px;
  cursor: pointer;
  margin-right: 10px;

  &:hover {
    background-color: #ff1c0f;
  }
`;

export const ButtonsContainer = styled.div`
  display: flex;
  align-items: center;
  margin-left: auto;
`;

export const AudioButton = styled.button`
  padding: 10px 15px;
  background-color: #007BFF;
  color: white;
  border: none;
  border-radius: 5px;
  cursor: pointer;

  &:hover {
    background-color: #0056b3;
  }

  i {
    font-size: 16px;
  }
`;

export const Countdown = styled.div`
  font-size: 2rem;
  color: white;
  text-align: center;
`;

export const AudioPreview = styled.audio`
  margin-right: 10px;
  max-width: 80%;
`;

export const Tooltip = styled.div`
  position: relative;
  display: inline-block;
  cursor: pointer;

  &:hover .tooltiptext {
    visibility: visible;
  }

  .tooltiptext {
    visibility: hidden;
    width: 120px;
    background-color: #555;
    color: #fff;
    text-align: center;
    border-radius: 5px;
    padding: 5px 0;
    position: absolute;
    z-index: 1;
    bottom: 125%; /* Position the tooltip above the text */
    left: 50%;
    margin-left: -60px;
    opacity: 0;
    transition: opacity 0.3s;

    &::after {
      content: "";
      position: absolute;
      top: 100%; /* At the bottom of the tooltip */
      left: 50%;
      margin-left: -5px;
      border-width: 5px;
      border-style: solid;
      border-color: #555 transparent transparent transparent;
    }
  }

  &:hover .tooltiptext {
    visibility: visible;
    opacity: 1;
  }
`;
